import {createApp} from "vue";
import {createPinia} from "pinia";

import App from "./app.vue"
import router from "./router"

import "bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";

import "@fontsource/roboto/300.css";
import "@fontsource/roboto/400.css";
import "@fontsource/roboto/500.css";
import "@fontsource/material-icons-rounded"

import "primevue/resources/primevue.min.css"
import "./assets/primevue-eeas/theme.css"
import "primeicons/primeicons.css"

import './assets/eeas/scss/eeas_global.scss'
import './assets/scss/schoolmaster.scss'

import PrimeVue from "primevue/config"
import Button from 'primevue/button'
import Checkbox from 'primevue/checkbox'
import InputText from 'primevue/inputtext'
import ScrollTop from 'primevue/scrolltop'
import Breadcrumb from 'primevue/breadcrumb'
import Dialog from 'primevue/dialog'
import Tooltip from 'primevue/tooltip'
import {useSharedStore} from "@/stores/useSharedStore";
import Utils from "@/views/shared/Utils";

const app = createApp(App);

app.use(createPinia());
app.use(router);
app.use(PrimeVue);
app.component("Button", Button);
app.component("Breadcrumb", Breadcrumb);
app.component("Checkbox", Checkbox);
app.component("InputText", InputText);
app.component("ScrollTop", ScrollTop);
app.component("Dialog", Dialog);
app.directive('tooltip', Tooltip)

const store = useSharedStore()
await store.fetchSharedData().catch((error) => {
    console.error('Failed to fetch shared data:', error)
});

app.mount("#app");

Utils.configDateSerializer();
